import React, { useEffect, useState } from 'react';
import 'react-phone-input-2/lib/material.css';
import { useFetch } from '../../hooks/useFetch';
import Modal from '@mui/material/Modal';
import { useNavigate } from 'react-router-dom';
import { LandingHeaderB2B } from './LandingHeaderB2B';
import { Footer } from '../footer/Footer';

const landingImages = require.context('../../assets/images', true);

export const LandingFormPage = () => {
  const [, handleFetch] = useFetch();
  const [showModalMailSending, setShowModalMailSending] = useState(false);
  const [showModalMailSendingError, setShowModalMailSendingError] = useState(false);
  const [name, setName] = useState('');
  const [nameson, setNameson] = useState('');
  const [typedocument, setTypedocument] = useState('');
  const [sonIdNumber, setSonIdNumber] = useState('');
  const [sonAge, setSonAge] = useState('');
  const [phone, setPhone] = useState('');
  const [terms, setTerms] = useState(false);
  const [setIsSmallScreen] = useState(window.innerWidth <= 1200);
  const [errors, setErrors] = useState({
    name: '',
    nameson: '',
    typedocument: '',
    sonIdNumber: '',
    sonAge: '',
    phone: '',
    asunto: '',
    terms: false,
  });
  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1200);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const handleInputChange = (e, setFunc) => {
    setFunc(e.target.value);
    setErrors({
      ...errors,
      [e.target.name]: '',
    });
  };
  const navigate = useNavigate();
  // Handle cerrar modal cuando se envía correo electrónico
  const handleCloseModal = () => {
    setShowModalMailSending(false);
    navigate('/');
  };
  // Handle cerrar modal cuando se envía correo electrónico en caso de error
  const handleCloseModalError = () => {
    setShowModalMailSendingError(false);
  };
  // Función para enviar datos de formulario de contacto
  const sendContactRequest = (e) => {
    e.preventDefault();
    let valid = true;
    const newErrors = {};
    if (name.trim() === '') {
      newErrors.name = 'El nombre es obligatorio';
      valid = false;
    }
    if (nameson.trim() === '') {
      newErrors.nameson = 'El nombre del hijo es obligatorio';
      valid = false;
    }
    if (typedocument.trim() === '') {
      newErrors.typedocument = 'El tipo de documento es obligatorio';
      valid = false;
    }
    if (sonIdNumber.trim() === '') {
      newErrors.sonIdNumber = 'La posición es obligatoria';
      valid = false;
    }
    if (phone.trim() === '') {
      newErrors.phone = 'El telefono es obligatorio';
      valid = false;
    }
    if (sonAge.trim() === '') {
      newErrors.sonAge = 'La edad del hijo es obligatorio';
      valid = false;
    }
    if (terms == false) {
      newErrors.terms = 'Debe aceptar los términos y condiciones';
      valid = false;
    }
    if (!valid) {
      setErrors(newErrors);
    } else {
      const response = handleFetch({
        url: 'contactus/sendmaildemob2b',
        method: 'POST',
        data: {
          name: name,
          nameson: nameson,
          typedocument: typedocument,
          sonIdNumber: sonIdNumber,
          sonAge: sonAge,
          phone: phone,
        },
      });
      response.then(
        () => {
          navigate('/gracias');
        },
        (error) => {
          console.log(error.errors);
          showModalMailSendingError(true);
        }
      );
    }
  };
  return (
    <>
      <ModalMailSending
        handleCloseModal={handleCloseModal}
        showModalMailSending={showModalMailSending}
      />
      <ModalMailSendingError
        handleCloseModal={handleCloseModalError}
        showModalMailSendingError={showModalMailSendingError}
      />
      <LandingHeaderB2B />
      <div className="container-fluid landing__FormSection py-4">
        <div className="container my-5 my-sm-2">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6 p-5 px-sm-2 py-sm-2 d-flex flex-column">
              <div className="col-12 col-md-12 col-lg-9 p-5 px-sm-2  mx-auto d-flex flex-column align-items-center">
                <div className="col-12 text-center">
                  <img
                    alt="INSCRÍBETE Y ASEGURA UN LUGAR PARA TU HIJO"
                    src={landingImages('./imgForm.png')}
                    className="img-fluid"
                    width="300"
                    height="100%"
                  />
                </div>
                <div className="col-12 landing__title-top-banner">
                  INSCRÍBETE
                  <br /> Y ASEGURA
                  <br /> UN LUGAR
                  <br /> PARA TU HIJO
                </div>
                <div className="col-12 landingb2b__text-respaldo-ean d-none d-md-block">
                  CON EL RESPALDO DE LA UNIVERSIDAD EAN{' '}
                  <img
                    alt="EAN UNIVERSIDAD"
                    src={landingImages('./eanunilogo.png')}
                    className="img-fluid"
                    width="120"
                    height="50"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="col-12 col-md-12 col-lg-10 landing__FormContent p-5 px-sm-2 d-flex flex-column">
                <div className="col-12 mb-4 d-flex justify-content-center align-items-center">
                  <p className="landing__h3-box">&#9632;</p>{' '}
                  <p className="landing__h3-form text-center">INSCRIBIRME</p>{' '}
                  <p className="landing__h3-box">&#9632;</p>
                </div>
                <form onSubmit={sendContactRequest}></form>
                <div className="input-container mt-3">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="input-container-input"
                    value={name}
                    onChange={(e) => handleInputChange(e, setName)}
                    required
                  />
                  <label htmlFor="name" className="input-container-label d-flex">
                    <p className="landing__inputs-box">&#9632;</p> Nombre del colaborador
                  </label>
                </div>
                <div className="alert-erros-b2b">
                  <label
                    className="form-check-label auth__form-label auth__required-input"
                    style={{ marginLeft: '10px', fontSize: '12px' }}
                  >
                    {errors.name}
                  </label>
                </div>
                <div className="input-container">
                  <input
                    type="tel"
                    id="phone"
                    className="input-container-input"
                    value={phone}
                    onChange={(e) => handleInputChange(e, setPhone)}
                    required
                  />
                  <label htmlFor="phone" className="input-container-label d-flex">
                    <p className="landing__inputs-box">&#9632;</p> Teléfono
                  </label>
                </div>
                <div className="alert-erros-b2b">
                  <label
                    className="form-check-label auth__form-label auth__required-input"
                    style={{ marginLeft: '10px', fontSize: '12px' }}
                  >
                    {errors.phone}
                  </label>
                </div>
                <div className="input-container">
                  <input
                    type="nameson"
                    id="nameson"
                    className="input-container-input"
                    value={nameson}
                    onChange={(e) => handleInputChange(e, setNameson)}
                    required
                  />
                  <label htmlFor="nameson" className="input-container-label d-flex">
                    <p className="landing__inputs-box">&#9632;</p> Nombre del hijo
                  </label>
                </div>
                <div className="alert-erros-b2b">
                  <label
                    className="form-check-label auth__form-label auth__required-input"
                    style={{ marginLeft: '10px', fontSize: '12px' }}
                  >
                    {errors.nameson}
                  </label>
                </div>
                <div className="input-container">
                  <input
                    type="text"
                    id="typedocument"
                    name="typedocument"
                    className="input-container-input"
                    value={typedocument}
                    onChange={(e) => handleInputChange(e, setTypedocument)}
                    required
                  />
                  <label htmlFor="typedocument" className="input-container-label d-flex">
                    <p className="landing__inputs-box">&#9632;</p> Tipo de Documento
                  </label>
                </div>
                <div className="alert-erros-b2b">
                  <label
                    className="form-check-label auth__form-label auth__required-input"
                    style={{ marginLeft: '10px', fontSize: '12px' }}
                  >
                    {errors.typedocument}
                  </label>
                </div>
                <div className="input-container">
                  <input
                    type="text"
                    id="sonIdNumber"
                    className="input-container-input"
                    value={sonIdNumber}
                    onChange={(e) => handleInputChange(e, setSonIdNumber)}
                    required
                  />
                  <label htmlFor="sonIdNumber" className="input-container-label d-flex">
                    <p className="landing__inputs-box">&#9632;</p> Número de identificación del hijo
                  </label>
                </div>
                <div className="alert-erros-b2b">
                  <label
                    className="form-check-label auth__form-label auth__required-input"
                    style={{ marginLeft: '10px', fontSize: '12px' }}
                  >
                    {errors.sonIdNumber}
                  </label>
                </div>
                <div className="input-container">
                  <input
                    type="text"
                    id="sonAge"
                    className="input-container-input"
                    value={sonAge}
                    onChange={(e) => handleInputChange(e, setSonAge)}
                    required
                  />
                  <label htmlFor="sonAge" className="input-container-label d-flex">
                    <p className="landing__inputs-box">&#9632;</p> Edad del hijo
                  </label>
                </div>
                <div className="alert-erros-b2b">
                  <label
                    className="form-check-label auth__form-label auth__required-input"
                    style={{ marginLeft: '10px', fontSize: '12px' }}
                  >
                    {errors.sonAge}
                  </label>
                </div>
                <div className="d-flex justify-content-center align-items-center check-terms mt-3">
                  <input
                    className="form-check-input-b2bform auth__form-check-b2bform"
                    type="checkbox"
                    value={terms}
                    onChange={(e) => handleInputChange(e, setTerms)}
                    required
                  />
                  <label
                    className="form-check-label auth__form-label"
                    style={{ marginLeft: '10px', fontSize: '12px' }}
                  >
                    Al enviar el formulario, aceptas los{' '}
                    <a href="https://eanx.co/terminos-condiciones.pdf" className="auth__link">
                      Términos y Condiciones
                    </a>{' '}
                    y Políticas de privacidad de EanX
                  </label>
                </div>
                <div className="alert-erros-b2b">
                  <label
                    className="form-check-label auth__form-label auth__required-input"
                    style={{ marginLeft: '10px', fontSize: '12px' }}
                  >
                    {errors.terms}
                  </label>
                </div>
                <div className="row justify-content-center text-center mt-5 mt-sm-2">
                  <button
                    type="submit"
                    className="col-12 landingb2b__button-primary px-5 py-3 border border-white"
                    onClick={sendContactRequest}
                  >
                    ENVIAR
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 text-center landingb2b__text-respaldo-ean d-block d-md-none">
            CON EL RESPALDO DE LA UNIVERSIDAD EAN{' '}
            <img
              alt="EAN UNIVERSIDAD"
              src={landingImages('./eanunilogo.png')}
              className="img-fluid"
              width="120"
              height="50"
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
// Función para mostrar mensaje exitoso en Modal de envío de solicitud
const ModalMailSending = ({ showModalMailSending, handleCloseModal }) => {
  return (
    <Modal
      open={showModalMailSending}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="ProfilePage__modal-base ProfilePage__outline-none">
        <div className="row justify-content-center align-items-center">
          <div className="col-4 text-center">
            <img
              src={landingImages('./icons/Nuestros-Expertos.png')}
              style={{ width: '65px', marginTop: '25px' }}
              alt="padlock"
            />
          </div>
          <div className="ProfilePage__modal-info-container">
            <div className="ProfilePage__modal-title">Solicitud enviada</div>
            <p className="ProfilePage__modal-text-description">
              Hemos recibido tu solicitud y estamos trabajando en ella, en cuanto tengamos una
              respuesta, nos comunicaremos contigo. No olvides revisar tu correo electrónico.
            </p>
            <div style={{ marginTop: '10px', marginBottom: '30px', textAlign: 'center' }}>
              <button
                className="col-12 landingb2b__button-primary px-5 py-3 border border-white"
                onClick={handleCloseModal}
                style={{ marginLeft: '0px' }}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
// Función para mostrar mensaje de error en Modal de envío de solicitud
const ModalMailSendingError = ({ showModalMailSendingError, handleCloseModal }) => {
  return (
    <Modal
      open={showModalMailSendingError}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="ProfilePage__modal-base ProfilePage__outline-none">
        <div className="row justify-content-center align-items-center">
          <div className="col-4 text-center">
            <img
              src={landingImages('./error.png')}
              style={{ width: '65px', marginTop: '25px' }}
              alt="padlock"
            />
          </div>
          <div className="ProfilePage__modal-info-container">
            <div className="ProfilePage__modal-title">Error al enviar</div>
            <p className="ProfilePage__modal-text-description">
              Ha ocurrido un error al tratar de enviar tu información, por favor intenta nuevamente.
            </p>
            <div style={{ marginTop: '10px', marginBottom: '30px', textAlign: 'center' }}>
              <button
                className="col-12 landingb2b__button-primary px-5 py-3 border border-white"
                onClick={handleCloseModal}
                style={{ marginLeft: '0px' }}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
